<template>
    <div class="home-page">
        <div class="top-menu">
            <div class="top">人工智能与机器视觉实验室</div>
            <div class="blank"></div>
            <div class="menu">
                <div class="menu-detail" @click="jumpToHome">首页</div>
                <div class="menu-detail" @click="jumpToTutor">导师风采</div>
                <div class="menu-detail" @click="jumpToTeam">科研团队</div>
                <div class="menu-detail" @click="jumpToPaper">论文成果</div>
                <div class="menu-detail" @click="jumpToHonor">获奖情况</div>
                <div class="menu-detail" @click="jumpToDownload">文件下载</div>
                <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToInnovation"> Innovation </div>
                <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToService"> Service </div>
                <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToInfluence_Contribution"> Influence and Contribution </div>
            </div>
        </div>
        <!-- 轮播图 -->
        <div class="page-content">
            
            <div class="news">
                <div class="news-title">新闻</div>
                <div class="splite"></div>
                <div class="news-content">
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2023.10，雷涛教授受邀参加2023 4th International Cofference on Computer Science and Management Technology (ICCSMT 2023)，并做大会主旨报告“Medical Image Segmentation under Constrained Conditions”
                        <a href="http://www.iccsmt.net/Speakers" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">ICCSMT 2023</span>
                        </a><span style="color: rgb(255, 0, 0);"><strong>    NEW !</strong></span><span style="color: rgb(255, 0, 0);"></span>
                        </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2023.08，恭喜实验室获得第十八届中国研究生电子设计竞赛全国一等奖以及全国总决赛最佳论文奖<span style="color: rgb(255, 0, 0);"><strong>NEW !</strong></span><span style="color: rgb(255, 0, 0);"></span>
                        </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2023.05，恭喜硕士生孙瑞同学的论文"CiT-Net: convolutional neural networks hand in hand with vision Transformers for medical image segmentation"被International Joint Conference on Artificial Intelligence 2023接受并在线发表
                        </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2023.05，恭喜硕士生耿信哲同学的论文"Ultralightweight Spatial–Spectral Feature Cooperation Network for Change Detection in Remote Sensing Images"被IEEE Transactions on Geoscience and Remote Sensing 2023接受并在线发表
                        </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2023.03，恭喜硕士生孙瑞同学的论文"SGU-Net: shape-guided ultralight network for abdominal image segmentation using adversarial consistency learning and dynamic convolution network"被IEEE Journal of Biomedical and Health Informatics 2023接受并在线发表
                        </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2023.03，恭喜硕士生张栋同学的论文" Semi-supervised medical image segmentation using adversarial consistency learning and dynamic convolution network"被IEEE Transactions on Medical Imaging 2023接受并在线发表
                        </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                         2022.03，恭喜硕士生耿信哲同学的论文"Global Evolution Neural Network for Segmentation of Remote Sensing Images"被IEEE International Conference on Acoustics,Speech, and Signal Processing 2022接受并在线发表
                        </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2022.03，恭喜硕士生刘虎林同学"Semi-Supervised 3D Medical Image Segmentation using Shape-Guided Dual Consistency Learning"被The IEEE International Conference on Multimedia & Expo 2022接受并在线发表
                        </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2021.11，恭喜实验室获得第七届中国国际“互联网+”大学生创新创业大赛研究生创意组国家级铜奖
                        </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2021.10，恭喜硕士生王日升同学获得2021年硕士研究生国家奖学金
                        </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2021.10，恭喜硕士生李林泽同学获得2021年硕士研究生国家奖学金
                        </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2021.06，恭喜硕士生张宇啸获得2021年硕士生优秀毕业论文
                        </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2021.06，恭喜本科生孙瑞、马熙琛获得2021年本科生优秀毕业论文
                        </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2021.06，恭喜硕士生张栋同学的论文“MFP-Net: Multi-scale Feature pyramid network for crowd counting”被IET Image Processing 接收并在线发表
                        </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2021.06，恭喜硕士生古东鑫同学的论文“HNSF Log-Demons: Diffeomorphic Demons Registration Using Hierarchical Neighborhood Spectral Features”被IET Image Processing 接收并在线发表
                        </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2021.06，恭喜硕士生王洁同学的论文“差异特征融合的无监督SAR图像变化检测”被智能系统学报 接收并在线发表
                        </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2021.04，恭喜硕士生洪璐敏子同学的论文“QAU-Net: Quartet attention U-Net for liver and liver-tumor Segmentation”，被IEEE International Conference on Multimedia and Expo 2021 接收并在线发表
                        </div>
                    
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2021.02，恭喜雷涛老师入选 Remote Sensing 期刊编委（SCI二区，TOP期刊，IF=4.509）<span style="color: rgb(255, 0, 0);"></span>
                        </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2021.02，恭喜硕士生王日升同学的论文“DefEnCe-Net: Deformable Encoding Context Network for Liver and Liver-Tumor
                        Segmentation”被IEEE Transactions on Radiation and Plasma Medical Sciences 接收并在线发表
                        <span style="color: rgb(255, 0, 0);"></span>
                        </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2021.02，恭喜博士生薛丁华同学的论文“Unsupervised Change Detection Using Multi-Scale and Multi-Resolution
                        Gaussian-Mixture-Model Guided by Saliency Enhancement”在IEEE Journal of Selected Topics in
                        Applied Earth Observations and Remote Sensing 发表 
                        <span style="color: rgb(255, 0, 0);"></span>
                        </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2021.01， 恭喜硕士生王日升同学的论文“Lightweight Non-local Network for image super-resolution”被ICASSP2021接收
                    </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2021.01，Remote Sensing专刊征稿，“可解释的深度网络模型在遥感影像理解中的应用”
                        <a href="https://www.mdpi.com/journal/remotesensing/special_issues/DeepNeuralNetworks" target="_self" style="user-select: auto;">[paper link]</a>
                    </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2020.10，恭喜硕士生张宇啸获得2020年国家奖学金。
                    </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2020.09，祝贺李云彤论文 "数据与模型联合驱动的陶瓷材料晶粒分割" 被 自动化学报录用  
                    </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2020.08，祝贺加小红博士论文 "Robust self-sparse fuzzy clustering for image segmentation" 被 IEEE Access录用 
                    </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2020.07，实验室论文入选 ESI 高被引论文， "Significantly fast and robust fuzzy c-means clustering   algorithms based on morphological reconstruction and membership   filtering," IEEE Transactions on Fuzzy Systems, vol. 26, no. 5, pp.   3027-3041, Oct. 2018.”
                    </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2020.07，恭喜保研学生尚佳童毕业论文《面向高分辨扫描电镜图像的快速分割算法研究》获得陕西科技大学优秀毕业设计二等奖。
                    </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2020.03，雷涛教授晋升为IEEE Senior Member 
                    </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                          2020.02，实验室论文 lightweight V-Net for liver segmentation 被ICASSP2020（Barcelona）录用
                    </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                         2019.11，恭喜博士生加小红获得2019年国家奖学金。
                    </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2019.11，11月12日成功举办“CSIG图像图形中国行”活动，邀请国内知名学者进行学术报告，加强各高校研究交流。
                    </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                         2019.10，将于2020.12.19-21在西安举办16th International Conference on   Natural Computation, Fuzzy Systems and Knowledge Discovery (ICNC-FSKD 2020)。
                    </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2019.9，与西安奥卡云数据科技有限公司针对人工智能、智慧物联网的发展和建设进行交流，并达成长期战略合作伙伴关系。
                    </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                          2019.9，悉尼科技大学董宣毅博士来实验室分享科研经验，并针对深度学习AutoML领域的常用方法和改进思路进行了详细的介绍。
                    </div>
                    <div class="news-word">
                        <i class="iconfont icon-yuandianzhong"></i>
                        2019.8，赴河北永泰化工集团对皮毛染色工艺中存在的问题进行交流探讨，并达成项目实质性合作。
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">Copyright© 2019 All Rights Reserved. 陕西科技大学人工智能与机器视觉实验室版权所有  </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                slipBox: [{
                    id: 0,
                        idView: require("../../assets/school4.jpg"),
                    },
                    //{
                    //    id: 1,
                    //    idView: require("../../assets/slip1.jpg"),
                    //},
                    //{
                    //    id: 2,
                    //    idView: require("../../assets/slip2.png"),
                    //},
                ],
            };
        },
        methods: {
            jumpToHome() {
                this.$router.push({
                    name: "home",
                });
            },
            jumpToTutor() {
                this.$router.push({
                    name: "tutor",
                });
            },
            jumpToTeam() {
                this.$router.push({
                    name: "team",
                });
            },
            jumpToPaper() {
                this.$router.push({
                    name: "paper",
                });
            },
            jumpToHonor() {
                this.$router.push({
                    name: "honor",
                });
            },
            jumpToDownload() {
                this.$router.push({
                    name: "download",
                });
            },
            jumpToInnovation() {
                this.$router.push({
                    name: "innovation",
                });
            },
            jumpToService() {
                this.$router.push({
                    name: "service",
                });
            },
            jumpToInfluence_Contribution() {
                this.$router.push({
                    name: "influence_contribution",
                });
            },
        },
    };
</script>

<style scoped>
    .home-page {
        background-color: #fffef9;
    }

    .top-menu {
        width: 100%;
    }

  .top {
      height: 12vh;
      width: 100%;
      background-image: url("../../assets/bg.jpg");
      color: white;
      font-size: 2.1vmax;
      font-weight: 500;
      line-height: 12vh;
      text-align: center;
      letter-spacing: 1vmax;
  }

  .menu {
      display: flex;
      flex-direction: row;
      height: 5vh;
      font-size: 1.1vmax;
      line-height: 5vh;
      padding-left: 3.1vmax;
      background-color: #dfe8ed;
  }

  .menu-detail {
    padding: 0 0.5vmax;
    cursor: pointer;
  }
    .menu-detail:hover {
        background-color: #fffef9;
    }

    .page-content {
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    /* 
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
  height: 700px;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
} */

    .slip {
        height: 700px;
        width: 90%;
        padding-left: 100px;
    }

    .slip-img {
        width: 100%;
    }

    .blank {
        background-color: #dfe8ed;
        height: 3px;
        width: 100%;
    }



    .splite {
        background-color: #85b0cc;
        width: 100%;
        height: 2px;
        margin: 10px 0;
    }

    .news {
        width: 100%;
    }

    .news-title {
        font-size: 20px;
        margin-top: 30px;
        margin-left: 60px;
    }

    .news-content {
        padding: 0 50px;
    }

    .news-word {
        line-height: 40px;
        font-size: 14px;
    }
    .footer{
        height: 70px;
        background-color: 	#575D64;
        color: #ffffff;
        line-height: 70px;
        text-align: center;
        margin-top: 30px;
    }
</style>